import { ClipControls } from "../../parameterWidgets/ClipControls";
import { ColorCodeSelector, PianoRoll } from "../../parameterWidgets/PianoRoll";
import { GrufModulADSR, GrufModulEQ, GrufModulSends } from "../../components/moduls";
import { ParameterKnob } from "../../parameterWidgets/ParameterKnob";
import SeparatorLine from "jsx:$assets/widgets/separator_line.svg";
import { HelpBox } from "../../components/HelpBox";
import { PresetBankBar } from "../../parameterWidgets/PresetBankBar";
import { WaveformSlider } from "../../parameterWidgets/WaveformSlider";
import { Legend } from "../../components/Legend";
import { capitalizeFirstLetter } from "../../utils/string";

export const SynthUI = ({instrument}) => {
    return (
        <SynthBaseUI instrument={instrument} synthesisParams={[["fx_distortion_amount", "hpf_cutoff"], ["osc_octave"]]}/>
    )
};

export const SynthBaseUI = ({instrument, synthesisParams=[[], []]}) => {
    return (
        <div className="estacio estacio-synth" style={{"--accent-color": instrument.metadata.color}}>
            <PresetBankBar instrument={instrument}/>
            <div className="modul-border modul-bg flex justify-between items-center">
                <ParameterKnob data-widget-id="instrumentVolume" mida="gran" parameterHandler={instrument.getParameterHandler("gain")} />
                <SeparatorLine className="h-full"/>
                <ParameterKnob data-widget-id="lpfCutoff" mida="gran" parameterHandler={instrument.getParameterHandler("lpf_cutoff")} />
            </div>
            <GrufModulEQ instrument={instrument} />
            <GrufModulSends instrument={instrument} className="square" />

            <HelpBox className="row-span-2 col-span-2" instrument={instrument} />

            <div />

            <fieldset data-widget-id="synthesis" className="modul-border modul-bg flex flex-col gap-20 justify-between items-center row-span-2">
                <Legend text="Síntesi" />
                <WaveformSlider instrument={instrument}/>
                <div className="flex-1 grid justify-between w-full" style={{gridTemplateColumns: "1fr auto 1fr", marginTop: -10}}>
                    <div className="flex flex-col justify-center gap-10">
                        {synthesisParams[0].map(paramName => <ParameterKnob data-widget-id={paramName.split("_").map((word, i) => i == 0 ? word : capitalizeFirstLetter(word)).join("")} mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(paramName)} />)}
                    </div>
                    <SeparatorLine className="h-full"/>
                    <div className="flex flex-col justify-center gap-10">
                        {synthesisParams[1].map(paramName => <ParameterKnob data-widget-id={paramName.split("_").map((word, i) => i == 0 ? word : capitalizeFirstLetter(word)).join("")} mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(paramName)} />)}
                    </div>
                </div>
            </fieldset>
            

            <GrufModulADSR instrument={instrument}/>


            <PianoRoll className="row-span-5" instrument={instrument} colorNotes={instrument.metadata.color} />
            <div className="flex gap-10 justify-between align-center">
                {instrument.getParameterDescription("pianoRollColorCode") && <ColorCodeSelector instrument={instrument}/>}
                <ClipControls className="contents" instrument={instrument} showAutogenerate/>
            </div>
        </div>
    )
};
